import { useState, useEffect } from 'react';
import { getRiderMissionList } from '../api/missionApi';
import { RiderMissionListResponse } from '../types/mission.types';

export const useMission = () => {
    const [missionData, setMissionData] = useState<RiderMissionListResponse | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetch = async () => {
            try {
                setIsLoading(true);
                const data = await getRiderMissionList();
                setMissionData(data);
            } catch (e) {
                setError('미션 정보를 불러오는데 실패했습니다.');
            } finally {
                setIsLoading(false);
            }
        };
        fetch();
    }, []);

    return { missionData, isLoading, error };
};
